import {
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { validMessage } from '../../../../constants/ValidsFormConst';
import { useNotification } from '../../../../helpers/Notification';
import { EstatusField, LoadingWidget } from '../../../../widgets';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { saveEntCarrerasAction } from '../EntCarrerasAction';

const FormEntCarreras = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const carrerasStore = Redux.useSelector((state) => state.carreras);
  const entCarrerasStore = Redux.useSelector((state) => state.entCarreras);

  const activo = entCarrerasStore.activo;

  const initData = {
    modalidad: 'PRESENCIAL',
    idCarrera: '',
    idEstatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    idCarrera: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    setTimeout(
      () =>
        setData({
          modalidad: activo.modalidad,
          idCarrera: activo.carrera.id,
          idEstatus: activo.estatus.id,
        }),
      300,
    );
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (!entidadesStore.activo) {
      notify('Falta seleccionar la entidad', { warning: true });
      return;
    }
    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await saveEntCarrerasAction(
        { dispatch, notify },
        activo?.id,
        {
          idEntidad: entidadesStore.activo.id,
          ...data,
        },
        entCarrerasStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        <LoadingWidget isLoading={loadingSave} isActivo={activo} />
        <Grid item xs={12} md={12}>
          <FormControl
            fullWidth
            size="small"
            required
            error={dataError.idCarrera}
          >
            <InputLabel id={`label_${CONST.carrera.name}`}>
              {CONST.carrera.label}
            </InputLabel>
            <Select
              id={CONST.carrera.name}
              required
              value={data.idCarrera}
              labelId={`label_${CONST.carrera.name}`}
              label={CONST.carrera.label}
              onChange={(e) =>
                _handleSetDataField(CONST.carrera.idName, e.target.value)
              }
            >
              {carrerasStore.all.map((el, index) => {
                return (
                  <MenuItem key={`carrera-${el.index}`} value={el.id}>
                    ({el.codigo}) - {el.nombre}
                  </MenuItem>
                );
              })}
            </Select>
            {dataError.idCarrera && (
              <FormHelperText>{validMessage.required}</FormHelperText>
            )}
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl
            fullWidth
            size="small"
            required
            error={dataError.modalidad}
          >
            <InputLabel id={`label_${CONST.modalidad.name}`}>
              {CONST.modalidad.label}
            </InputLabel>
            <Select
              required
              id={CONST.modalidad.name}
              value={data.modalidad}
              labelId={`label_${CONST.modalidad.name}`}
              label={CONST.modalidad.label}
              onChange={(e) =>
                _handleSetDataField(CONST.modalidad.name, e.target.value)
              }
            >
              <MenuItem value="PRESENCIAL">Presencial</MenuItem>
              <MenuItem value="REMOTO">Remoto</MenuItem>
            </Select>
            {dataError.modalidad ? (
              <FormHelperText>{validMessage.required}</FormHelperText>
            ) : null}
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <EstatusField
            value={data.idEstatus}
            onChange={(e) =>
              _handleSetDataField(CONST.estatus.idName, e.target.value)
            }
            isEstatus
            required
            error={dataError.estatus}
          />
        </Grid>
        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormEntCarreras;
